import { useEffect, useState } from 'react';

// Trail a fast-changing value by `ms` (Lion Auto's live preview waits for the
// pricer to stop editing before it spends a match call). The value must stay
// referentially stable between real changes — memoize objects in the caller —
// or the timer restarts on every render and keeps re-setting state.
export function useDebouncedValue(value, ms = 400) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return debounced;
}

export default useDebouncedValue;
